import { apiProvider } from "./utilities/provider";
import { JsonDocument } from "./utilities/json";
import { Release } from "../../models/release";

export const releaseApi = {
  get: (): Promise<Release> =>
    apiProvider.getAll("release").then((d: JsonDocument<Release>) => d.data),
};
